import _ from 'lodash'
import api from '../../../../../api'
import { Engine } from 'json-rules-engine'
import FieldRequirementValidator from '../../../share/mixins/FieldRequirementValidator'
import FormClient from '@/components/bundles/intvhs/share/form/forms/formClient.js'
import Loader from '../../../../share/Loader'
import SubSchema from '../../share/form/SubSchema.vue'

export default {
  name: 'schema',
  template: `
    <form v-if="isVisible && rulesLoaded">
    <SubSchema
      :model="model"
      :rawSchemas="rawSchemas"
      :rules="rules"
      :options="formOptions"
      :category-group="categoryGroup"
      :service="service"
      :modelLoaded="modelLoaded"
      @saveField="handleSubmitData"
      @addCollectionItem="handleSubmitData"
      @removeCollectionItem="handleSubmitData"
    />
    </form>`,
  components: {
    SubSchema
  },
  mixins: [
    Loader,
    FieldRequirementValidator,
    FormClient
  ],
  props: {
    service: {type: String, required: true},
    task: { type: Object, required: true, default () { return {} } },
    taskData: { type: Object, required: true, default () { return {} } },
    categoryGroup: {type: String, required: true}
  },
  data () {
    return {
      rulesEngine: this.createRulesEngine(),
      rulesLoaded: false,
      // service: this.$route.meta.acl.service,
      isVisible: false,
      schemaName: 'appraisal',
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        fieldIdPrefix: 'task-'
      },
      model: {},
      modelChanged: {},
      modelLoaded: false,
      rules: {},
      schema: {
        groups: []
      },
      rawSchemas: null,
      fieldSendDataMap: {
        voivodeship: {
          method: this.getModelDataByPath,
          args: ['label']
        },
        county: {
          method: this.getModelDataByPath,
          args: ['label']
        },
        borough: {
          method: this.getModelDataByPath,
          args: ['label']
        },
        city: {
          method: this.getModelDataByPath,
          args: ['label']
        },
        postCode: {
          method: this.getModelDataByPath,
          args: ['postcode']
        }
      }
    }
  },
  created () {
    this.loadSchema()
    this.loadData()
    this.getRules()
  },
  mounted () {
    this.$events.on(`${this.service}:${this.categoryGroup}:refetchTaskComplete`, this.handleUpdateData)
    this.$events.on(`${this.service}:${this.categoryGroup}:refetchTask`, this.getRules)
    this.$store.commit('SET_CURRENT_TASK_MODEL', this.model)
  },
  updated () {
    this.validateRequirement()
  },
  methods: {
    getModelDataByPath (model, prop) {
      if (typeof model === 'string') {
        return model
      }

      return _.has(model, prop) ? _.get(model, prop) : null
    },
    createRulesEngine () { return new Engine() },
    loadData () {
      this.model = Object.assign({}, this.model, this.taskData)
      // if (this.task.state) {
      //   this.$events.$emit('dashboard:submenu:appraisalTaskInInitialState', this.task.state.initial)
      //   if (!this.task.state.initial && !this.task.state.final) {
      //     this.$events.$emit('dashboard:submenu:showAll')
      //   }
      // }
      this.modelLoaded = true
      // this.handleButtonsVisibility(this.task)
      this.$events.$emit('dashboard:submenu:taskLoaded')
    },
    getLoadSchemaMethod () {
      return this.$isWithClients(this.service)
        ? api.request(this.service, 'get', `/schemas/${this.schemaName}`, { state: this.task.state.id, client: this.$route.meta.client })
        : api.request(this.service, 'get', `/schemas/${this.schemaName}`, { state: this.task.state.id })
    },
    loadSchema () {
      this.getLoadSchemaMethod()
        .then((result) => {
          this.rawSchemas = result.data
          this.isVisible = true
          this.loaded = true
          this.$notify({
            type: 'success',
            text: 'Schemat formularza załadowany poprawnie'
          })
        }).then(() => {
          this.$events.$emit('dashboard:submenu:taskLoaded')
        })
        .catch(() => {
          this.toggleLoading()
          this.$notify({
            type: 'error',
            text: 'Błąd ładowania schematu formularza'
          })
        })
    },
    formatSourceModelName (source) {
      return source.split('').filter(char => char !== '[' && char !== ']' && char !== '.').join('')
    },
    getMetadataMethod () {
      return api.request(this.service, 'get', `/tasks/metadata/${this.task.id}`)
    },
    getRules () {
      this.getMetadataMethod().then(({data}) => {
        this.rules = data
        this.rulesLoaded = true
      }).catch((e) => {
        this.rulesLoaded = true
        this.errorNotify(e)
      })
      .finally(() => this.$store.commit('SET_PENDING', false))
    },
    handleUpdateData (data) {
      this.model = Object.assign({}, data.taskData)
    },
    handleSubmitData (data) {
      this.validateRequirement()

      let submitData = {
        service: this.service,
        apiParams: {
          method: 'put',
          url: this.$isWithClients(this.$route.meta.acl.service) ? `/tasks/${this.$route.params.appraisalTaskId}` : `/tasks/${this.$route.params.id}/appraisal/${this.$route.params.appraisalTaskId}`
        },
        data: this.createDataToSend(data),
        taskId: this.task.id,
        taskCategory: this.categoryGroup,
        target: data.target
      }

      this.processSubmitField(submitData)
    },
    createDataToSend (data) {
      let schema = data.schema
      let newVal = schema.type === 'metadataMultiSelect' && _.has(data, 'value.id') ? data.value.id : data.value
      let dataToSend = {}
      dataToSend[schema.model] = newVal

      if (this.fieldSendDataMap[schema.model] !== undefined) {
        newVal = this.fieldSendDataMap[schema.model].method(newVal, ...this.fieldSendDataMap[schema.model].args)
      }
      dataToSend[schema.model] = newVal

      if (schema.hasOwnProperty('relatedFields')) {
        schema.relatedFields.forEach((relatedField) => {
          if (this.fieldSendDataMap[relatedField] !== undefined) {
            dataToSend[relatedField] = this.fieldSendDataMap[relatedField].method(this.model[relatedField], ...this.fieldSendDataMap[relatedField].args)
          }
        })
      }

      if (this.$isWithClients(this.service)) {
        dataToSend['appraisal'] = true
        dataToSend['client'] = this.$route.meta.client
      }
      return dataToSend
    }
  }
}
